import { useEffect as m } from "react";
import t from "./index80.mjs";
import { useStorage as S } from "./index44.mjs";
import { StorageKey as i } from "./index43.mjs";
import { CookiesEnum as s } from "./index42.mjs";
const f = (o) => t.get(s.BrowserSessionActiveId) === o.toString(), u = (o, n = {}) => {
  const e = t.get(s.LoginId) ?? "shared", r = S(`${i.SessionStorePrefix}${e}:${o}`, n);
  return m(() => {
    f(e) || (r.removeByPrefix(i.SessionStorePrefix), t.set(s.BrowserSessionActiveId, e.toString(), {
      sameSite: "strict",
      path: "/"
    }));
  }, [e, r.removeByPrefix]), r;
};
export {
  u as useSessionStore
};
